import { formatDate } from '@if/core/utils'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { CreditReportForeignInquiry } from '@src/data/types'
import { useTranslation } from 'react-i18next'
import Row from './tableRow'

interface ForeignInquirieProps {
  foreignInquiries: CreditReportForeignInquiry[]
}

const ForeignInquiries = ({ foreignInquiries }: ForeignInquirieProps) => {
  const { t } = useTranslation()
  return (
    <Row id="foreignInquiries" name={t('creditReport.foreignInquiries')}>
      <TableContainer>
        <Table sx={{ display: 'contents' }} aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Date</TableCell>
              <TableCell align="left">{t('creditReport.cityOrInquiryNumber')}</TableCell>
              <TableCell align="left">Province</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {foreignInquiries.map((item) => (
              <TableRow key={item.cityNameOrInquiryNumber} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  {formatDate(item.date)}
                </TableCell>
                <TableCell align="left">{item.cityNameOrInquiryNumber}</TableCell>
                <TableCell align="left">{item.province}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Row>
  )
}

export default ForeignInquiries
